import styled from 'styled-components'

export const StyleMenuAccount = styled.div<{ isDarkMode?: boolean }>`
  .menu-account {
    padding: 2px;
    margin-top: 4px;
    .account-name {
      line-height: 1.2;
    }
    .btn-logout {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 8px;
      font-size: 14px !important;
      font-weight: 600;
      span {
        svg {
          width: 20px;
          height: 20px;
          path {
            fill: rgb(237, 17, 23);
          }
        }
      }
    }
    /* #656565 */
    .btn-function {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 8px;
      font-size: 14px !important;
      span {
        svg {
          width: 20px;
          height: 20px;
          path {
            fill: #9a9a9a;
          }
        }
      }
    }
    .strok-btn-function {
      span {
        svg {
          width: 20px;
          height: 20px;
          path {
            fill: #9a9a9a;
            stroke: #9a9a9a;
          }
        }
      }
    }
    .ant-dropdown-menu-item {
      background: #fff !important;
      padding: 2px 0px;
    }
    .ant-dropdown-menu-item:hover {
      background: #f5f5f5 !important;
    }
    .ant-dropdown-menu,
    .ant-menu,
    .ant-menu-root {
      position: relative !important;
      width: 100% !important;
      padding: 0 !important;
      box-shadow: unset;
      background: none;
      border: none !important;
      border-right: none !important;
      &::after {
        display: none !important;
      }
      .account-infor {
        background: #fff;
        padding: 6px 12px 0px 12px;
        border-radius: 20px 20px 3px 3px;
        margin-bottom: 0px;
        .ant-divider {
          margin: 6px 0px 2px 0px;
        }
        .infor {
          margin-bottom: 2px;
        }
        .sumary-infor-user {
          display: flex;
          justify-content: center;
          align-items: flex-start;
          flex-direction: column;
          height: 100%;
        }
      }
      .account-function {
        background: #fff;
        padding: 6px 12px;
        border-radius: 3px;
        margin-bottom: 2px;
      }
      .account-logout {
        background: #fff;
        padding: 6px 12px;
        border-radius: 3px 3px 20px 20px;
      }
    }
  }
`
